// export  const reg_phone = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
export  const reg_phone = /^1(3[0-9]|4[5-9]|5[0-35-9]|6[56]|7[0-8]|8[0-9]|90|9[1-9])\d{8}$/